
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salle-de-reunion/[zone]/[district]",
      function () {
        return require("private-next-pages/salle-de-reunion/[zone]/[district].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salle-de-reunion/[zone]/[district]"])
      });
    }
  